import { render, staticRenderFns } from "./SingleFileTagSwitch.vue?vue&type=template&id=6bcd8e82"
import script from "./SingleFileTagSwitch.vue?vue&type=script&lang=js"
export * from "./SingleFileTagSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports